<template>
    <v-row justify="center">
        <v-btn
            @click.stop="dialog = true"
            :color="mainColor"
            dark
            small
            v-show="!onLoading"
        >
            Agregar nuevo colaborador
        </v-btn>
        <v-dialog width="400px" v-model="dialog">
            <v-card>
              <v-container>
                <app-alert @dismissed="onDismissed" :text="error" v-if="error !== ''"></app-alert>
                <v-row  >
                  <v-col class="text-center" >
                      <h2 :style="`color:${mainColor}`">Ingrese el ID del colaborador</h2>
                  </v-col>
                  <v-col cols="12" class="pl-5 pr-5">
                    <v-text-field
                        label="ID"
                        outlined
                        v-model="collabId"
                        :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card-actions>
                            <v-col class="text-center" >
                                <v-btn
                                :color="mainColor"
                                text
                                @click="dialog=false"
                                >Cerrar</v-btn>
                                <v-btn
                                :loading="onLoading"
                                :disabled="onLoading"
                                :color="mainColor"
                                :dark="!onLoading"
                                @click="onSaveCollab"
                                >Guardar</v-btn>
                            </v-col>
                        </v-card-actions>
                    </v-col>
                </v-row>
              </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
/* eslint-disable no-console */
import { mdiAccountPlusOutline } from '@mdi/js'
import * as constants from '../../../../constants.json'

export default {
  data () {
    return {
      collabId: '',
      addUserIcon: mdiAccountPlusOutline,
      dialog: false,
      mainColor: constants.MAINCOLOR,
      error: '',
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    }
  },

  methods: {
    async onSaveCollab () {
      try {
        const companyData = this.$store.getters.getCompanyData

        await this.$store.dispatch('actionAddCollab', {
          companyId: companyData.companyId,
          companyName: companyData.companyName,
          companyPhotoUrl: companyData.companyPhotoUrl,
          collabId: this.collabId
        })
      } catch (error) {
        this.error = error
      }
    },

    onDismissed () {
      console.log('Dismissed Alert')
      this.error = ''
    }
  }
}
</script>
